var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.screenHolder)?_c('div',{staticClass:"screenholder"},[_c(_vm.$store.state.screenHolder,{tag:"component"})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }